import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadOutlineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.2 4.4a1.2 1.2 0 1 0-2.4 0v12.3l-3.1-3.1q-1-.7-1.7 0-.7.8 0 1.7l5.2 5.2q.8.6 1.6 0l5.3-5.2q.6-1 0-1.7-1-.7-1.7 0l-3.2 3.1zm-9 12.4H8A3 3 0 0 0 4.8 20v4c0 1.8 1.4 3.2 3.2 3.2h16c1.8 0 3.2-1.4 3.2-3.2v-4c0-1.8-1.4-3.2-3.2-3.2h-.1l-2.4 2.4H24q.7.1.8.8v4q-.1.7-.8.8H8a1 1 0 0 1-.8-.8v-4q.1-.7.8-.8h2.5zm15 5.2a1.2 1.2 0 1 0-2.4 0 1.2 1.2 0 1 0 2.4 0" })
});
export default SvgDownloadOutlineIcon;
